import type React from 'react';
import styled from 'styled-components';

type YellowDotProps = {
  width?: string;
  height?: string;
  right?: string;
  top?: string;
};

const StyledYellowDot = styled.div<{
  $width?: string;
  $height?: string;
  $right?: string;
  $top?: string;
}>`
  width: ${({ $width = '10px' }) => $width};
  height: ${({ $height = '10px' }) => $height};
  background-color: ${({ theme }) => theme.colors.focoltone};
  box-shadow: 2px 2px 13px  ${({ theme }) => theme.colors.focoltone};
  border-radius: 50%;
  position: absolute;
  z-index: 10;
  right: ${({ $right = '6px' }) => $right};
  top: ${({ $top = '0px' }) => $top};
  animation: beat 1.5s ease-in-out infinite;
  
  @keyframes beat {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
`;

export const YellowDot: React.FC<YellowDotProps> = ({
  width = '10px',
  height = '10px',
  right = '6px',
  top = '0px',
}) => {
  return <StyledYellowDot $width={width} $height={height} $right={right} $top={top} />;
};
